import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import httpClient from 'utils/httpClient';

const UPDATE_TEACHING_STATUS = `/v2/teacher/teaching-status`;

export type UpdateTeachingStatusBody = {
  isReady: number;
};

export type UpdateTeachingStatusResponse = {};

export const updateTeachingStatus = ({ isReady }: UpdateTeachingStatusBody) => {
  return httpClient.put<UpdateTeachingStatusResponse>(UPDATE_TEACHING_STATUS, {
    'is-ready': isReady,
  });
};

export const useUpdateTeachingStatus = (
  opts?: UseMutationOptions<
    AxiosResponse<UpdateTeachingStatusResponse>,
    AxiosError<any>,
    UpdateTeachingStatusBody
  >,
) =>
  useMutation<
    AxiosResponse<UpdateTeachingStatusResponse>,
    AxiosError<any>,
    UpdateTeachingStatusBody
  >(updateTeachingStatus, opts);
